module.exports = __webpack_public_path__ + "static/media/verdana.74702fcb.woff";